import React, { useState } from 'react';

export default function FaqItem({ question, children }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item${open ? ' faq-item--open' : ''}`}>
      <button
        type="button"
        className="faq-item__question"
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
      >
        <span>{question}</span>
        <span className="faq-item__icon" aria-hidden="true">{open ? '−' : '+'}</span>
      </button>
      <div className="faq-item__answer">
        <div className="faq-item__answer-inner">{children}</div>
      </div>
    </div>
  );
}
